<script>
    import { recommenderProposals } from '../api/recommender';

    export default {
        props: {
            questions: { type: Array, default: () => [] },
            pageLang: { type: String, default: '' },
            pageId: { type: [String, Number], default: '' },
            proposalId: { type: [String, Number], default: '' },
            isEditMode: { type: Boolean, default: false },
            ungatedProposals: { type: Boolean, default: false },
            preselectedAnswers: { type: Array, default: () => [] },
            formUrl: { type: String, default: '' },
            formOrigin: { type: String, default: '' }
        },
        data: function () {
            return {
                selectedAnswers: this.preselectedAnswers && this.preselectedAnswers.length > 0 ? this.preselectedAnswers : [],
                params: {
                    'language': this.pageLang,
                    'pageId': this.pageId
                },
                proposals: [],
                index: '',
                isLoading: false,
                buttonSubmitted: false,
                formSubmitted: false,
                iframeUrl: null,
                formId: 'recommender-form',
                iframeHeight: 0,
                formLoaded: false
            };
        },
        created() {
            if (this.selectedAnswers.length > 0) {
                this.getProposals();
            }
            if (this.proposalId !== '') {
                this.params.proposalId = this.proposalId;
            }
        },
        mounted() {
            const formHandlersLoadEvent = new CustomEvent('form-handlers-loaded', {});
            window.dispatchEvent(formHandlersLoadEvent);
        },
        computed: {
            hasPreselectedAnswers() {
                return this.preselectedAnswers && this.preselectedAnswers.length > 0;
            },
            filtersDisabled() {
                return !this.isEditMode && !this.ungatedProposals && (this.hasPreselectedAnswers || this.buttonSubmitted);
            },
            allQuestionsAnswered() {
                return this.selectedAnswers.length === this.questions.length;
            }
        },
        methods: {
            handleButtonSubmit() {
                this.buttonSubmitted = true;

                if (!this.isEditMode && !this.ungatedProposals) {
                    this.iframeUrl = this.proposalId !== '' ? this.formUrl : null;
                    window.addEventListener(
                        "message",
                        (e) => {
                            if (e.origin === this.formOrigin) {
                                //task handlings
                                switch (e.data["task"]) {

                                    case "pardotShow" || "formShow":
                                        this.formLoaded = true;

                                        break;


                                    case "pardotClear" || "formClear":
                                        if (e.data["formID"] === this.formId) {
                                            this.getProposals();
                                        }

                                        break;

                                    case "pardotSendPageData" || "formSendPageData":
                                        this.sendPageData();

                                        break;

                                    case "pardotFormHeight" || "formHeight":
                                        if (e.data["formID"] === this.formId && e.data["formHeight"] > 0) {
                                            this.iframeHeight = e.data["formHeight"] + 10; //Add 10px extra
                                            this.setIframeHeight();
                                        }

                                        break;
                                }
                            }
                        },
                        false
                    );
                    window.addEventListener("resize", this.setIframeHeight());
                }
                else {
                    this.getProposals();
                }
            },

            getProposals() {
                this.formSubmitted = true;
                this.params.answers = this.selectedAnswers.toString();
                this.isLoading = true;
                recommenderProposals(this.params)
                    .then(response => {
                        this.proposals = response;
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            setIframeHeight() {
                if (!this.$refs || !this.$refs.iframeElement) return;

                this.$refs.iframeElement.style.height = this.iframeHeight + 'px';
            },
            sendPageData() {
                const data = {
                    task: 'siteData',
                    formID: this.formId,
                    lang: document.querySelector('html').getAttribute('lang'),
                    pageName: document.title,
                    masterName: window.masterPageName,
                    masterUrl: window.masterPageUrl
                };
                if (!this.$refs.iframeElement) return;
                this.$refs.iframeElement.contentWindow.postMessage(data, this.formOrigin || '*');
            },
            resetPage() {
                window.location = window.location.href.split('?')[0];
            },
            copyUrl() {
                const input = document.getElementById('urlContainer');
                if (!input) return;
                input.value = window.location.href.split('?')[0] + '?id=' + this.proposalId;
                input.focus();
                input.select();
                try {
                    document.execCommand('copy');
                } catch (e) { }
                const bubble = document.getElementsByClassName('bubble')[0];
                if (bubble) {
                    bubble.style.display = 'block';
                    setTimeout(() => {
                        bubble.style.display = 'none';
                    }, 1500);
                }
            },
            handleBtnClick(index, question, answer) {
                if (typeof dataLayer !== 'undefined' && dataLayer) {
                    dataLayer.push({
                        event: 'recommender_usage',
                        recommender: {
                            step: index,
                            key: question,
                            value: answer
                        }
                    });
                }
            }
        }

    };
</script>